import { render, staticRenderFns } from "./CommentSearch.vue?vue&type=template&id=4fa66304&"
import script from "./CommentSearch.vue?vue&type=script&lang=js&"
export * from "./CommentSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports